export default "__VITE_ASSET__663db31f__"